@let isQuotation = this.isQuotation();
@if (isQuotation) {
    <div class="no-quotation-container">
        <img src="shared-assets/images/company-search/man-with-binocular.svg" />
        <div class="no-quotation-text">
            <p class="hint">
                {{ 'NO_SPECIALIST_DEALER_WITH_OFFER' | translate }}
            </p>
            <p>{{ 'INSTEAD_SCHEDULE_LOCAL_APPOINTMENT' | translate }}</p>
            <warema-button
                [iconRight]="'search'"
                [text]="'TOOL_OVERVIEW_DESC.SPECIALIST_DEALERS_SEARCH' | translate"
                (click)="findDealer.emit()"
            />
        </div>
    </div>
} @else {
    <div class="message-container">{{ 'COMPANY_SEARCH.NO_DEALER_WITH_APPOINTMENT_REQUEST' | translate }}</div>
}
